import { useTypeNames as useCoreTypeNames } from '@fv/client-core'

import { useAppSettings } from './settings'

export function useTypeNames() {
  return useCoreTypeNames(useAppSettings)
}
